import(/* webpackMode: "eager" */ "/home/runner/work/egalite-incluipcd/egalite-incluipcd/apps/incluipcd/src/assets/info/people-smiling-and-working.png");
;
import(/* webpackMode: "eager" */ "/home/runner/work/egalite-incluipcd/egalite-incluipcd/apps/incluipcd/src/assets/info/woman-doing-sign-language.png");
;
import(/* webpackMode: "eager" */ "/home/runner/work/egalite-incluipcd/egalite-incluipcd/apps/incluipcd/src/assets/info/woman-looking-at-camera.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/egalite-incluipcd/egalite-incluipcd/apps/incluipcd/src/blocks/About/Content.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/egalite-incluipcd/egalite-incluipcd/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/egalite-incluipcd/egalite-incluipcd/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/egalite-incluipcd/egalite-incluipcd/packages/ui/IncluiPCD/Home/Hero/SquigglyLines.tsx");
